<template>
  <el-container class="body_container">
    <el-header style="height: 50px;padding:0px">
      <el-row type="flex">
        <el-col class="body_title">权限管理</el-col>
      </el-row>
    </el-header>
    <el-container>
      <el-aside style="background-color: #fff;width: 25%;margin-right: 10px" class="role_list">
        <el-table :data="roleData" highlight-current-row @row-click="findResource">
          <el-table-column prop="name" label="角色列表"></el-table-column>
        </el-table>
      </el-aside>
      <el-main style="background-color: #fff;">
        <el-row>
          <el-col>
            <el-tree
              :data="tableData"
              show-checkbox
              default-expand-all
              node-key="id"
              ref="tree"
              highlight-current
              @check-change="handleCheckChange"
              :default-checked-keys="selectedData"
              :props="defaultProps">
            </el-tree>
          </el-col>
        </el-row>
        <el-row style="margin-top: 40px;text-align:left">
          <el-col>
            <el-button @click="confirmPermission">确定</el-button>
            <!--<el-button @click="resetPermission">重置</el-button>-->
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import role from '@/api/role'
import resource from '@/api/resource'
export default {
  name: 'Permission',
  data () {
    return {
      roleData: [],
      resourceData: [],
      tableData: [],
      selectedData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      roleId: '',
      sysPermssion: {}
    }
  },
  methods: {
    reload () {
      role.findNotPage({name: this.roleName}).then(res => {
        this.roleData = res.data.data
      })
      resource.list({keyword: ''}).then(res => {
        this.tableData = res.data.data
      })
    },
    findResource (row) {
      this.resetPermission()
      this.roleId = row.id
      role.findResourceByRoleId({id: row.id}).then(res => {
        this.resourceData = res.data.data
        this.getSelectData()
        if (this.selectedData.length ===0) {
          this.$message({
            type: 'warning',
            message: '暂无分配权限'
          });
          this.reload()
        }
      })
    },
    handleCategory (row) {
      return row.category==='M'? '菜单': row.category === 'A'? '操作': '未知'
    },
    getSelectData () {
      let arr = []
      this.getDiGui(this.tableData,this.resourceData,arr)
      // console.log(this.selectedData)
    },
    getDiGui (tableData,resourceData,arr){
      for (let j = 0; j < resourceData.length;j++){
        for (let i = 0;i < tableData.length; i++) {
          if (tableData[i].id === resourceData[j].id) {
            if (this.selectedData.indexOf(resourceData[j].id) === -1) {
              arr.push(resourceData[j].id)
            }
          }
          if (tableData[i].children!=null && tableData[i].children.length !==0) {
            this.getDiGui(tableData[i].children,resourceData,arr)
          }else {
            continue;
          }
        }
      }
      this.selectedData=arr
    },
    handleCheckChange (data, checked, indeterminate) {
      if (checked) {
        if (this.selectedData.indexOf(data.id) === -1) {
          this.selectedData.push(data.id)
        }
      } else {
        if (this.selectedData.indexOf(data.id) !== -1) {
          this.selectedData.splice(this.selectedData.indexOf(data.id),1)
        }
      }
      // console.log(this.selectedData)
    },
    confirmPermission () {
      this.sysPermssion.roleId = this.roleId
      this.sysPermssion.rids = this.selectedData
      role.saveResource(this.sysPermssion).then(res => {
        if (res.data.code===0) {
          this.$message({
            type: 'success',
            message: res.data.message
          });
          this.reload()
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          });
        }
      })
    },
    resetPermission () {
      this.selectedData = []
      this.getSelectData()
      this.reload()
    }
  },
  created() {
    this.reload()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/system/Permission.vue